import Dashboard from "../components/dashboard/Dashboard";
import NotFound from "../components/NotFound";
import Error from "../components/Error";
import LevelTestQuiz from "../components/games/LevelTest";
import NewGame from "../components/NewGame";
import NewGameMultiplayer from "../components/NewGameMultiplayer";
import ProfileIndex from "../components/Profile/Index";
import Multiplayer from "../components/games/Multiplayer";
import SinglePlayer from "../components/games/SinglePlayer";
import GameHistory from "../components/GameHistory";
import Wip from "../components/partial/Wip";
import FindGame from "../components/FindGame";
import Scholar from "../components/games/Scholar/Scholar";
import Connect from "../components/games/Scholar/Connect";
import AgainstComputer from "../components/games/AgainstComputer/Index";
import NewsPage from "../components/NewsPage";
import Article from "../components/Article";

import authenticated from "./middleware/authenticated";
import connectToWebsocket from "./middleware/connectToWebsocket";
import SimpleGroupGame from "../components/games/SimpleGroupGame/SimpleGroupGame";
import CreateSimpleGroupGameRoom from "../components/games/SimpleGroupGame/CreateRoom";
import NewGameFriend from "../components/NewGameFriend";
import NewGameGroup from "../components/NewGameGroup";
import FindGroupGame from "../components/games/SimpleGroupGame/FindGroupGame";
import NewsList from "../components/NewsList";
import Achievements from "../components/Achievements";
import AchievementGroups from "../components/AchievementGroups";
import Notifications from "../components/Notifications";
import StoreComponent from "../components/Store";
import Statistics from "../components/Statistics";
import PublicProfile from "../components/PublicProfile";
import GameReview from "../components/GameReview";
import Settings from "../components/Profile/Settings";
import AfterRegistration from "../components/AfterRegistration";

export default [
    {
        path: '/404',
        component: NotFound
    },
    {
        path: '/500',
        component: Error
    },
    {
        path: '*',
        component: NotFound
    },

    {
        path: '/first-step',
        component: AfterRegistration,
        name: 'after-registration',
        meta: {
            hasNavigation: false,
            middleware: [
                authenticated
            ],
        }
    },

    {
        path: '/',
        component: Dashboard,
        name: 'dashboard',
        meta: {
            hasNavigation: true
        }
    },

    {
        path: '/profile',
        name: 'profile',
        component: ProfileIndex,
        meta: {
            hasNavigation: true,
        }
    },

    {
        path: '/profile/settings',
        name: 'profile-settings',
        component: Settings,
        meta: {
            hasNavigation: true
        }
    },

    {
        path: '/profile/history',
        component: GameHistory,
        meta: {
            middleware: [
                authenticated
            ],
            requiresAuth: true
        }
    },

    {
        path: '/new-game',
        component: NewGame,
        meta: {
            hasNavigation: true
        }
    },

    {
        path: '/new-game/multiplayer',
        component: NewGameMultiplayer,
        meta: {
            hasNavigation: true,
            middleware: [
                authenticated,
            ]
        }
    },

    {
        path: '/game/multiplayer/play-with-friend',
        component: NewGameFriend,
        meta: {
            hasNavigation: true,
            middleware: [
                authenticated,
            ]
        }
    },

    {
        path: '/game/multiplayer/group-game',
        component: NewGameGroup,
        meta: {
            hasNavigation: true,
            middleware: [
                authenticated,
            ]
        }
    },

    {
        path: '/game/multiplayer/random',
        component: Multiplayer,
        meta: {
            gamePage: true,
            hasNavigation: true,
            middleware: [
                authenticated,
                connectToWebsocket
            ]
        }
    },

    {
        path: '/game/find-game',
        component: FindGame,
        meta: {
            hasNavigation: true,
            middleware: [
                authenticated,
                connectToWebsocket
            ]
        }
    },

    {
        path: '/game/invited-multiplayer',
        component: Multiplayer,
        props: {
            privateGame: true
        },
        meta: {
            gamePage: true,
            middleware: [
                authenticated,
                connectToWebsocket
            ]
        }
    },

    {
        path: '/game/scholar',
        component: Scholar,
        meta: {
            middleware: [
                authenticated,
                connectToWebsocket
            ]
        }
    },

    {
        path: '/game/simple-group-game',
        component: CreateSimpleGroupGameRoom,
        meta: {
            middleware: [
                authenticated,
                connectToWebsocket
            ]
        }
    },

    {
        path: '/game/find-group-game',
        component: FindGroupGame,
        meta: {
            hasNavigation: true,
            middleware: [
                authenticated,
                connectToWebsocket
            ]
        }
    },

    {
        path: '/g/:code',
        component: SimpleGroupGame,
        name: 'findSimpleGroupGame',
        props: route => {
            return {
                code: route.params.code
            }
        },
        meta: {
            middleware: [
                authenticated,
                connectToWebsocket
            ]
        }
    },

    {
        path: '/game/invited-multiplayer/:code',
        component: Multiplayer,
        props: route => {
            return {
                code: route.params.code,
                privateGame: true
            }
        },
        meta: {
            gamePage: true,
            middleware: [
                authenticated,
                connectToWebsocket
            ]
        }
    },

    {
        path: '/game/scholar-multiplayer/:code',
        component: Multiplayer,
        props: route => {
            return {
                code: route.params.code,
                scholarGame: true
            }
        },
        meta: {
            gamePage: true,
            middleware: [
                connectToWebsocket
            ]
        }
    },

    {
        path: '/s/:code',
        component: Connect,
        name: 'findScholarRoom',
        props: route => {
            return {
                code: route.params.code
            }
        },
        meta: {
            middleware: [
                connectToWebsocket
            ]
        }
    },

    {
        path: '/game/level-test',
        component: LevelTestQuiz,
        meta: {
            gamePage: true,
        }
    },

    {
        path: '/game/singleplayer',
        component: SinglePlayer,
        meta: {
            gamePage: true,
            middleware: [
                authenticated
            ]
        }
    },

    {
        path: '/game/play-against-computer',
        component: AgainstComputer,
        meta: {
            gamePage: true,
            middleware: [
                authenticated
            ]
        }
    },

    {
        path: '/wip',
        component: Wip
    },

    {
        path: '/news/:slug',
        component: NewsPage,
        name: 'news',
        props: route => {
            return {
                slug: route.params.slug
            }
        }
    },

    {
        path: '/article/:slug',
        component: Article,
        name: 'article',
        props: route => {
            return {
                slug: route.params.slug
            }
        }
    },

    {
        path: '/news',
        component: NewsList,
        name: 'newsList',
    },

    {
        path: '/achievements',
        component: AchievementGroups,
        name: 'achievementGroups',
        meta: {
            hasNavigation: true,
            middleware: [
                authenticated
            ]
        }
    },

    {
        path: '/achievements/:group_id',
        component: Achievements,
        name: 'achievements',
        props: route => {
            return {
                group_id: route.params.group_id
            }
        },
        meta: {
            hasNavigation: true,
            middleware: [
                authenticated
            ]
        }
    },

    {
        path: '/notifications',
        component: Notifications,
        name: 'notifications',
        meta: {
            hasNavigation: true,
            middleware: [
                authenticated
            ]
        }
    },

    {
        path: '/store',
        component: StoreComponent,
        name: 'store',
        meta: {
            hasNavigation: true,
            middleware: [
                authenticated
            ]
        }
    },

    {
        path: '/statistics',
        component: Statistics,
        name: 'statistics',
        meta: {
            hasNavigation: true,
            middleware: [
                authenticated
            ]
        }
    },

    {
        path: '/user/:id',
        component: PublicProfile,
        name: 'user-profile',
        props: route => {
            return {
                id: route.params.id
            }
        }
    },

    {
        path: '/game-review/:quizId',
        component: GameReview,
        name: 'gameReview',
        props: route => {
            return {
                quizId: route.params.quizId
            }
        },
        meta: {
            hasNavigation: true,
            middleware: [
                authenticated
            ]
        }
    },
];
